function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { TYPE_TRANSLATION } from 'researcher/digital-orders/constants';
import { getLanguageOptionsOfPurchases } from 'researcher/digital-orders/reducer';
import { convertFormDataToDigitalOrderUpdateRequest } from 'shared/view/digital-order-conversion-service';
import { Controls, validators, useFormHelpers } from 'shared/helper/form';
import Files, { endpoints, Components } from 'shared/helper/file';
import { T } from 'shared/helper/translate';
import DigitalTranslationUploadButton from './DigitalTranslationUploadButton';
var fileType = 'digitalTranslation';
var Form = Controls.Form,
  Radio = Controls.Radio;
var notEmpty = validators.notEmpty;
var FileWithPopoverErrorStatus = Components.FileWithPopoverErrorStatus;
var defaultValues = {
  digitalTranslationFiles: [],
  language: '',
  type: TYPE_TRANSLATION
};
var languageOptions = function languageOptions(allowedLanguages) {
  return allowedLanguages.map(function (language) {
    return _objectSpread(_objectSpread({}, language), {}, {
      label: /*#__PURE__*/React.createElement(T, {
        source: language.term
      })
    });
  });
};
var SubmitDigitalTranslationForm = function SubmitDigitalTranslationForm(_ref) {
  var createDigitalOrder = _ref.createDigitalOrder,
    initialLanguageSelection = _ref.initialLanguageSelection;
  var allowedLanguages = useSelector(getLanguageOptionsOfPurchases);
  var methods = useForm({
    defaultValues: defaultValues,
    shouldFocusError: false
  });
  var _useFormHelpers = useFormHelpers(),
    preprocessData = _useFormHelpers.preprocessData;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    submitting = _useState2[0],
    setSubmitting = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    dragActive = _useState4[0],
    setDragActive = _useState4[1];
  var _methods$watch = methods.watch(['digitalTranslationFiles']),
    _methods$watch2 = _slicedToArray(_methods$watch, 1),
    digitalTranslationFiles = _methods$watch2[0];
  var hasFile = digitalTranslationFiles && digitalTranslationFiles.length > 0;
  var submitDigitalTranslation = function submitDigitalTranslation(data) {
    setSubmitting(true);
    createDigitalOrder(data).then(function () {
      window.scrollTo(0, 0);
      setSubmitting(false);
      methods.reset(defaultValues);
    });
  };
  useEffect(function () {
    methods.setValue('language', initialLanguageSelection);
  }, [initialLanguageSelection]);
  return /*#__PURE__*/React.createElement("div", {
    className: "p-3 submit-digital-translation-form mt-2 ".concat(dragActive ? 'hovered' : '')
  }, /*#__PURE__*/React.createElement(Form, {
    methods: methods,
    onSubmit: preprocessData(convertFormDataToDigitalOrderUpdateRequest, submitDigitalTranslation)
  }, /*#__PURE__*/React.createElement("div", {
    className: "row text-small"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("h4", null, /*#__PURE__*/React.createElement(T, {
    source: "digital-translations-start"
  }), /*#__PURE__*/React.createElement("span", {
    className: "ms-2 badge bg-secondary rounded text-white text-small align-middle"
  }, /*#__PURE__*/React.createElement(T, {
    source: "digital-translations-uses-one-use"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-5"
  }, /*#__PURE__*/React.createElement("label", {
    className: "control-label text-secondary text-transform-none"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Manuscript File (.doc or .docx)"
  })), /*#__PURE__*/React.createElement(Files, {
    apiRoot: endpoints.researcher,
    maxUploads: 1,
    methods: methods,
    name: "digitalTranslationFiles",
    type: fileType,
    disabled: submitting,
    fileRenderer: FileWithPopoverErrorStatus,
    required: true,
    fileUploadButton: function fileUploadButton(_ref2) {
      var onClick = _ref2.onClick,
        isDragActive = _ref2.isDragActive,
        disabled = _ref2.disabled;
      return /*#__PURE__*/React.createElement(DigitalTranslationUploadButton, {
        onClick: onClick,
        isDragActive: isDragActive,
        disabled: disabled,
        onDragStatusChanged: function onDragStatusChanged(active) {
          return setDragActive(active);
        },
        hasFile: hasFile
      });
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-4"
  }, /*#__PURE__*/React.createElement(Radio, {
    label: "language",
    messages: {
      notEmpty: 'Please make a selection'
    },
    name: "language",
    options: languageOptions(allowedLanguages),
    styles: {
      label: 'text-secondary text-transform-none',
      wrapper: 'mb-3 control-group pb-0'
    },
    validators: {
      notEmpty: notEmpty
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-3"
  }, /*#__PURE__*/React.createElement("button", {
    disabled: submitting,
    type: "submit",
    className: "btn btn-primary mt-3 position-relative rounded text-transform-none"
  }, /*#__PURE__*/React.createElement(T, {
    source: "translate"
  }), submitting ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-1",
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }) : null)))));
};
export default SubmitDigitalTranslationForm;